<template>
  <AppHeaderDropdown right no-caret v-if="$store.state.currentUser.id">
    <template slot="header">
      <i class="icon-bell"></i><b-badge pill variant="danger">{{ obj ? obj.length : 0 }}</b-badge>
    </template>
    <template slot="dropdown">

      <b-list-group style="width:400px">

        <b-list-group-item href="#" class="flex-column align-items-start"  variant="secondary" v-if="!obj || obj.length <= 0">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1 text-center"><small>Nenhuma notificação</small></h5>
          </div>        
        </b-list-group-item>
        
        <b-list-group-item href="#" class="flex-column align-items-start" v-for="item in obj" :key="item.id" v-else>
          <div class="d-flex w-100 justify-content-between">
            <b-dropdown-item :variant="item.message.priority==1 ? 'danger' : (item.message.priority == 3 ? '' : 'primary')"><i class="icon-user-follow"></i>{{ $utils.parseHtml(item.message.bodyText) }}</b-dropdown-item>
          </div>      
        </b-list-group-item>

      </b-list-group>

    </template>
  </AppHeaderDropdown>
</template>
<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownNotif',
  props: {
    obj: Array
  },
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      
     }
  }
}
</script>
